var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"display-stats-panel"},_vm._l((_vm.stats),function(stat,index){return _c('article',{key:index,staticClass:"stat-card"},[_c('p',{staticClass:"stat-label"},[_vm._v(_vm._s(stat.label))]),_c('p',{staticClass:"stat-value"},[_vm._v(_vm._s(stat.value))]),_c('p',{staticClass:"stat-hint"},[_vm._v(_vm._s(stat.hint))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }